import React from "react";

export default function Footer({ business }) {
  return (
    <footer
      className="bg-stone-900 text-stone-300 pt-14 pb-8"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#993311] text-stone-50 grid place-items-center font-serif text-lg">
                H
              </span>
              <div>
                <div className="font-serif text-2xl text-stone-50">Halli Chutney</div>
                <div className="font-hand text-[#f2c15b] text-sm -mt-1">taste of the village</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-stone-400 max-w-sm leading-relaxed">
              Handcrafted village-style chutneys from Karnataka, delivered to your
              home. Made with real ingredients, real recipes, real love.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-stone-500 mb-4">Explore</div>
            <ul className="space-y-2">
              {[
                { l: "Our Story", h: "#about" },
                { l: "Shop", h: "#shop" },
                { l: "Reviews", h: "#reviews" },
                { l: "Contact", h: "#contact" },
              ].map((i) => (
                <li key={i.h}>
                  <a
                    href={i.h}
                    className="text-sm text-stone-300 hover:text-[#f2c15b] transition-colors"
                    data-testid={`footer-link-${i.l.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {i.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-stone-500 mb-4">Reach us</div>
            <ul className="space-y-2 text-sm text-stone-300">
              <li>{business.phone || "+91 63633 64092"}</li>
              <li>{business.email || "hello@hallichutney.com"}</li>
              <li className="text-stone-400">{business.location || "Bangalore, Karnataka"}</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-stone-500">
            © {new Date().getFullYear()} Halli Chutney. Handmade with care in Karnataka.
          </div>
          <div className="font-hand text-[#f2c15b] text-lg">— ruchi mane vari</div>
        </div>
      </div>
    </footer>
  );
}
